import React from "react";

export const formatDateView = (separator) => {
  const dateFormat = `YYYY${separator}MM${separator}DD`;
  return dateFormat;
};

/**
 * Check if market consent is given based on leadDetails terms
 * @param {Object} record - The record object containing leadDetails
 * @returns {boolean} - True if consent is given (terms includes "4")
 */
export const hasMarketConsent = (record) => {
  const terms = record?.leadDetails?.[0]?.terms;
  return terms?.includes("4") || false;
};

/**
 * Render market consent as "Yes" or "No" for table columns
 * @param {any} text - The text value (unused but required for table render)
 * @param {Object} record - The record object containing leadDetails
 * @returns {React.ReactNode} - JSX element with "Yes" or "No"
 */
export const renderMarketConsent = (text, record) => {
  const hasConsent = hasMarketConsent(record);
  return <div>{hasConsent ? "Yes" : "No"}</div>;
};

/**
 * Market consent column definition for Ant Design Table
 * Use this in your columns array to add the Market Consent column
 */
export const marketConsentColumn = {
  title: "Market Consent",
  key: "market_consent",
  width: 100,
  render: renderMarketConsent,
};